var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.maxTimes),function(i){return _c('span',{key:i,staticClass:"tag mx-1",class:{ 'is-success': i <= _vm.times }})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }